import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

const Loader = () => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
    }}
  >
    <CircularProgress sx={{ color: "var(--red-color)" }} />
  </Box>
);

export default Loader;
